module.exports = __webpack_public_path__ + "img/cp4-1.c5dea127.jpg";